import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { Cluster } from 'src/app/models/api/comercial/cluster';

@Injectable({
  providedIn: 'root'
})
export class ApiClusterService {
  private baseUrl = 'Cluster';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<Cluster[]>('');
  }
}
